module.exports = __webpack_public_path__ + "static/media/Koffie-Bonen.865a82fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/categories/Koffie-Bonen.jpg
// module id = 318
// module chunks = 0